<template>
  <div class="privacy-statement">
    <div>
      <strong>PRIVACY STATEMENT RENTRUNNER B.V.</strong>
    </div>
    <div>
      <div>RentRunner B.V.</div>
      <div>Broekdijk 2</div>
      <div>5125 NE Hulten</div>
      <div>T: +31 (0) 85 020 6800</div>
      <div>
        E: <a href="mailto:rent@rentrunner.eu">rent@rentrunner.eu</a>
      </div>
    </div>

    <div class="underline">Algemeen</div>
    <p>
      RentRunner B.V. (hierna: RentRunner) levert diensten op het gebied van
      vervangend vervoer. RentRunner verzorgt binnen Europa voor diverse
      alarmcentrales, automerken, etc. vervangend vervoer voor reizigers die
      gestrand zijn. RentRunner hecht veel belang aan het waarborgen van uw
      privacy en de bescherming van uw persoonsgegevens. Bij de verwerkingen van
      persoonsgegevens door RentRunner wordt rekening gehouden met de geldende
      privacywetgeving.
    </p>

    <div class="underline">Beveiligingsmaatregelen</div>
    <p>
      RentRunner neemt de bescherming van uw (persoons)gegevens serieus en neemt
      passende maatregelen om misbruik, verlies, onbevoegde toegang, ongewenste
      openbaarmaking en ongeoorloofde wijziging tegen te gaan. Denk bijvoorbeeld
      aan versleuteling van uw persoonsgegevens die u aan ons doorgeeft via onze
      app. Als u de indruk heeft dat uw gegevens niet goed beveiligd zijn of er
      aanwijzingen zijn van misbruik, neem dan contact met ons op.
    </p>
    <div class="underline">Verwerking van persoonsgegevens</div>
    <p>
      RentRunner verwerkt slechts persoonsgegevens wanneer hiervoor een
      wettelijke verwerkingsgrondslag aanwezig is. Bij RentRunner zijn in elk
      geval de volgende wettelijke verwerkingsgrondslagen aanwezig:
      <br />
      • <i>Noodzakelijk voor het uitvoeren van een overeenkomst.</i>
      Noodzakelijk voor het uitvoeren van een overeenkomst. U sluit met
      RentRunner een huurovereenkomst voor vervangend vervoer. In het kader van
      deze overeenkomst verwerken wij uw persoonsgegevens, zoals uw naam, adres,
      postcode, geboortedatum, telefoonnummer, e-mailadres, kentekennummer van
      het eigen voertuig en rijbewijsnummer. Wij vragen een kopie van uw
      rijbewijs.
      <br />
      • <i>Gerechtvaardigde belangen.</i>
      Bij het verwerken van uw persoonsgegevens op basis van deze grondslag zal
      het niet gaan om een zuiver commercieel belang van RentRunner. Het gaat
      dan bijvoorbeeld om gegevens die u bij ons achterlaat om contact op te
      nemen (als wij nog geen overeenkomst gesloten hebben).
      <br />
      • <i>Toestemming.</i> Voor het verwerken van bijvoorbeeld de foto op uw
      rijbewijs, vragen wij uw toestemming.
      <br />
      • <i>Noodzakelijk om te voldoen aan een wettelijke plicht.</i> Hierbij kan
      gedacht worden aan fiscale bewaartermijnen voor bepaalde gegevens ten
      behoeve van de Belastingdienst, zoals facturen. Ook zijn wij in bepaalde
      gevallen wettelijk verplicht uw persoonsgegevens door te geven aan andere
      partijen.
    </p>
    <div class="underline">Derden</div>
    <p>
      RentRunner verstrekt uw persoonsgegevens slechts aan derden als dat
      wettelijk verplicht is of als dat noodzakelijk is in het kader van onze
      dienstverlening (en bijvoorbeeld een samenwerkingsovereenkomst gesloten is
      met de derde). Gegevens kunnen in voorkomende gevallen bijvoorbeeld
      uitgewisseld worden met verzekeraars, alarmcentrales en depots. Ook deelt
      RentRunner persoonsgegevens met Fine Company en CJIB voor het incasseren
      van bekeuringen. RentRunner maakt in het kader van de dienstverlening
      tevens gebruik van meerdere digitale systemen waarin persoonsgegevens
      worden verwerkt, zoals een systeem voor e-mailverkeer en facturatie. Met
      organisaties die dergelijke systemen aanbieden bestaan afspraken ter
      waarborging van uw persoonsgegevens.
    </p>
    <div class="underline">Delen van gegevens buiten de EER</div>
    <p>
      Uw persoonsgegevens worden door RentRunner niet gedeeld met partijen
      gevestigd buiten
      <a
        href="https://www.rijksoverheid.nl/onderwerpen/europese-unie/vraag-en-antwoord/welke-landen-horen-bij-de-europese-economische-ruimte-eer"
        >de Europese Economische Ruimte (EER)</a
      >. Wanneer persoonsgegevens wel gedeeld worden met partijen buiten de EER,
      dan wordt u hierover nader geïnformeerd.
    </p>

    <div class="underline">Bewaartermijn</div>
    <p>
      RentRunner bewaart uw (persoons)gegevens niet langer dan noodzakelijk voor
      de doeleinden waarvoor deze verwerkt worden, tenzij dit nodig is om te
      voldoen aan wettelijke verplichtingen. Voor de meeste administratieve
      (persoons)gegevens en documenten geldt bijvoorbeeld op basis van fiscale
      wetgeving een bewaartermijn van ten minste 7 jaar. Gegevens die u bij ons
      heeft achtergelaten in het kader van de huurovereenkomst, bewaren wij in
      beginsel gedurende 5 jaar na afloop van de huurovereenkomst.
    </p>

    <div class="underline">
      Persoonsgegevens van bezoekers jonger dan 16 jaar
    </div>

    <p>
      Onze website en/of dienst heeft niet de intentie gegevens te verzamelen
      over websitebezoekers die jonger zijn dan 16 jaar, tenzij wij toestemming
      hebben van ouders of voogd. We kunnen echter niet controleren of een
      bezoeker ouder dan 16 jaar is. Wij raden ouders dan ook aan betrokken te
      zijn bij de onlineactiviteiten van hun kinderen, om zo te voorkomen dat er
      gegevens over kinderen verzameld worden zonder ouderlijke toestemming. Als
      u vermoedt dat wij zonder die toestemming persoonlijke gegevens hebben
      verzameld over een minderjarige, neem dan contact met ons op, dan
      verwijderen wij deze informatie.
    </p>
    <div class="underline">Cookies en passieve tracking</div>
    <p>
      De website van RentRunner maakt gebruik van cookies. Een "cookie" is een
      gegevenselement dat naar uw browser kan worden verzonden. Uw browser kan
      het dan op uw systeem opslaan op basis van de voorkeuren die u in uw
      browser hebt ingesteld. Cookies verzamelen informatie over uw
      besturingssysteem, inclusief, maar niet beperkt tot, browsertype en
      Internet Protocol (IP) -adres.
    </p>
    <p>
      RentRunner gebruikt cookies om:
      <br />
      • de website geschikt te maken voor uw interesses;
      <br />
      • de basisfunctionaliteit van de website goed te laten werken;
      <br />
      • gebruikersstatistieken te genereren op een anonieme basis om de website
      meer gebruikersvriendelijk te maken.
    </p>
    <p>
      RentRunner gebruikt deze informatie om het verkeer op de website te
      analyseren, om zowel de paginaweergaven als de tijdsduur op elke pagina te
      bekijken en u beter van dienst te zijn wanneer u terugkeert naar de
      website. Het is niet onze bedoeling deze informatie te gebruiken om een
      ​​gebruiker persoonlijk te identificeren. Deze informatie wordt verzameld
      in een geaggregeerde en anonieme vorm.
    </p>
    <p>
      U hebt de mogelijkheid om uw internetbrowser te configureren om u op de
      hoogte te stellen wanneer u een cookie ontvangt, zodat u kunt beslissen of
      u deze accepteert. Verder heeft u de mogelijkheid om alle cookies te
      blokkeren. Houd er echter rekening mee dat als u cookies weigert of
      anderszins blokkeert, u mogelijk niet alle beschikbare functies op de
      website kunt gebruiken. Bepaalde onderdelen van de website kunnen niet
      werken als u cookies blokkeert.
    </p>

    <div class="underline">Vragen en rechten</div>
    <p>
      Wilt u inzage hebben in de persoonsgegevens die wij van u verwerken of
      wilt u uw (persoons)gegevens ontvangen (in het kader van
      dataportabiliteit) of laten corrigeren, wijzigen, aanvullen of
      verwijderen? Ook heeft u in bepaalde gevallen het recht bezwaar te maken
      tegen een verwerking of om een verwerking te beperken. Dien uw verzoek in
      via onderstaande contactgegevens. Wij kunnen u wel vragen om uzelf
      adequaat te identificeren door middel van een legitimatiebewijs. Hiervoor
      verzoeken we u om uw foto, MRZ (Machine Readable Zone, de strook met
      nummers onderaan het legitimatiebewijs), document- of paspoortnummer en
      BSN onherkenbaar te maken. Ook kunnen wij vragen om nadere informatie om
      inwilliging van uw verzoek mogelijk te maken, zoals het toezenden van
      documentatie.
    </p>
    <p>
      Wij beantwoorden uw verzoek tot inzage, ontvangst, correctie, wijzing,
      aanvulling, verwijdering, bezwaar en beperking binnen een redelijke
      termijn. Deze redelijke termijn is uiterlijk vier weken na uw verzoek,
      identificatie en eventueel aanvullende documentatie. Onder bepaalde
      omstandigheden zijn wij gerechtigd de termijn te verlengen met maximaal
      twee maanden. Ons antwoord kan een bevestiging zijn dat uw verzoek wordt
      ingewilligd of een weigering die met redenen is omkleed.
    </p>
    <p>
      Bovenstaande verzoeken kunt u richten aan
      <a href="mailto:rent@rentrunner.eu">rent@rentrunner.eu</a>.
    </p>

    <div class="underline">Geautomatiseerde besluitvorming</div>
    <p>
      Bij RentRunner wordt u niet onderworpen aan geautomatiseerde besluitvorming. Dit houdt in dat er altijd een persoon zit achter onze beslissingen, bijvoorbeeld als u een voertuig wilt huren.
    </p>

    <div class="underline">Klacht indienen</div>
    <p>
      U heeft het recht een klacht in te dienen bij de Autoriteit Persoonsgegevens als u het vermoeden heeft dat uw persoonsgegevens niet conform de geldende privacywetgeving verwerkt worden. We hopen wel dat u eerst contact met ons opneemt, zodat we samen kunnen proberen eruit te komen.
    </p>
    <div class="underline">Wijzigingen</div>
    <p>
      RentRunner behoudt zich het recht voor deze privacy statement op ieder gewenst moment te wijzigen. Deze wijzigingen worden bekendgemaakt via de websites van RentRunner. De meest actuele versie kunt u vinden op de websites. We adviseren u regelmatig op de webpagina’s van het privacy statement te kijken of veranderingen zijn doorgevoerd. RentRunner kan uw persoonsgegevens verwerken voor nieuwe doeleinden die nog niet vermeld staan in deze verklaring, zolang deze doelen aansluiten bij het doel waarvoor de gegevens verzameld zijn.
    </p>
    <div class="underline">Vragen</div>
    Mocht u vragen of opmerkingen hebben, dan kunt u contact opnemen via
    <a href="mailto:rent@rentrunner.eu">rent@rentrunner.eu</a>.
  </div>
</template>

<script>
export default {
  name: "privacy-statement",
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped>
.privacy-statement {
  padding: 40px;
}
.underline {
  text-decoration: underline;
}
</style>
